import { Box, Theme } from "@outschool/backpack";
import { ParentFragmentFragment } from "@outschool/gql-frontend-generated";
import { gql, useQuery } from "@outschool/ui-apollo";
import { AttachmentFragment } from "@outschool/ui-components-classroom";
import React, { ReactNode } from "react";

import { PhotoReviews } from "../categories/curated/CuratedReviews";
import { AlwaysVisiblePhotosDisclaimerText } from "../ParentProfile/PrivacyDisclaimerText";

const photoFeedbackByUserQuery = gql`
  query PhotoFeedbackByUserQuery($userUid: ID!) {
    photoFeedbackByUser(userUid: $userUid) {
      uid
      attachments {
        ...AttachmentFragment
      }
    }
  }
  ${AttachmentFragment}
`;

export default function PhotoReviewCarousel({
  parent,
  title,
  isCurrentUsersProfile
}: {
  title: ReactNode;
  parent: ParentFragmentFragment;
  isCurrentUsersProfile: boolean;
}) {
  const { data, error, loading } = useQuery(photoFeedbackByUserQuery, {
    variables: { userUid: parent.uid }
  });

  if (!data || loading || error) {
    return null;
  }

  if (!data.photoFeedbackByUser.length) {
    return null;
  }

  return (
    <Box
      sx={(theme: Theme) => ({
        mx: "1em",
        mb: "1rem",
        maxWidth: "100%",
        paddingBottom: "64px",
        [theme.breakpoints.down("sm")]: { mx: 0 }
      })}
    >
      {title}
      {isCurrentUsersProfile && <AlwaysVisiblePhotosDisclaimerText />}
      <Box sx={{ marginTop: "1em" }}>
        <PhotoReviews reviews={data.photoFeedbackByUser} hideCaption />
      </Box>
    </Box>
  );
}
